import { useEffect, useState } from 'react';
import api from '../../api/axios';
import MasterEditModal from '../../components/MasterEditModal';

export default function Categories() {
  const [manufacturers, setManufacturers] = useState([]);
  const [manufacturerId, setManufacturerId] = useState('');
  const [rows, setRows] = useState([]);
  const [name, setName] = useState('');
  const [editRow, setEditRow] = useState(null);
  const [editForm, setEditForm] = useState({ manufacturer_id: '', name: '' });
  const [saving, setSaving] = useState(false);

  useEffect(() => { api.get('/manufacturers').then((r) => setManufacturers(r.data)); }, []);
  useEffect(() => { if (manufacturerId) api.get(`/categories/by-manufacturer/${manufacturerId}`).then((r) => setRows(r.data)); }, [manufacturerId]);

  const add = async () => { if (!name || !manufacturerId) return; await api.post('/categories', { name, manufacturer_id: manufacturerId }); setName(''); api.get(`/categories/by-manufacturer/${manufacturerId}`).then((r) => setRows(r.data)); };
  const openEdit = (row) => {
    setEditRow(row);
    setEditForm({ manufacturer_id: row.manufacturer_id || manufacturerId, name: row.name || '' });
  };
  const update = async () => {
    if (!editForm.name.trim() || !editForm.manufacturer_id || !editRow) return;
    setSaving(true);
    try {
      await api.put(`/categories/${editRow.id}`, { name: editForm.name, manufacturer_id: editForm.manufacturer_id });
      setEditRow(null);
      api.get(`/categories/by-manufacturer/${manufacturerId}`).then((r) => setRows(r.data));
    } finally {
      setSaving(false);
    }
  };
  const remove = async (row) => {
    if (!window.confirm('تأكيد الحذف؟')) return;
    await api.delete(`/categories/${row.id}`);
    api.get(`/categories/by-manufacturer/${manufacturerId}`).then((r) => setRows(r.data));
  };

  return (
    <div>
      <div className="grid md:grid-cols-3 gap-2 mb-3">
        <select className="rounded-lg border p-2" value={manufacturerId} onChange={(e) => setManufacturerId(e.target.value)}>
          <option value="">اختر الشركة</option>
          {manufacturers.map((m) => <option key={m.id} value={m.id}>{m.name}</option>)}
        </select>
        <input value={name} onChange={(e) => setName(e.target.value)} className="rounded-lg border p-2" placeholder="اسم الفئة" />
        <button onClick={add} className="rounded-lg bg-primary px-3 py-2 text-white">إضافة</button>
      </div>
      <table className="w-full text-sm border rounded-lg overflow-hidden">
        <thead className="bg-slate-100"><tr><th className="p-2 text-right">الاسم</th><th className="p-2">إجراءات</th></tr></thead>
        <tbody>{rows.map((r) => <tr key={r.id} className="border-t"><td className="p-2">{r.name}</td><td className="p-2 flex gap-2 justify-center"><button onClick={() => openEdit(r)} className="px-2 py-1 border rounded">تعديل</button><button onClick={() => remove(r)} className="px-2 py-1 border rounded text-red-600">حذف</button></td></tr>)}</tbody>
      </table>

      <MasterEditModal
        open={Boolean(editRow)}
        title="تعديل الفئة"
        subtitle="يمكن تعديل اسم الفئة والشركة المرتبطة بها."
        fields={[
          {
            name: 'manufacturer_id',
            label: 'الشركة',
            type: 'select',
            required: true,
            options: [{ value: '', label: 'اختر الشركة' }, ...manufacturers.map((m) => ({ value: String(m.id), label: m.name }))],
          },
          { name: 'name', label: 'اسم الفئة', required: true },
        ]}
        values={editForm}
        onChange={(key, value) => setEditForm((current) => ({ ...current, [key]: value }))}
        onClose={() => setEditRow(null)}
        onSubmit={update}
        saving={saving}
      />
    </div>
  );
}
